import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import {
    resetFilteringStateAction,
    updateIsNewOnlyAction,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import { setLeadsFilterValue } from "app/pages/sales-intelligence/modules/leads-search-filters/store/action-creators";
import { appliedSignalsChangedAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import * as ac from "./action-creators";
import initialAppsSearchState from "./initial-state";
import type { AppsSearchTableState } from "./types";

type FilterChangeActions =
    | typeof updateIsNewOnlyAction
    | typeof setLeadsFilterValue
    | typeof appliedSignalsChangedAction;

const appsSearchReducer = createReducer<
    AppsSearchTableState,
    ActionType<typeof ac | FilterChangeActions> | ReturnType<typeof resetFilteringStateAction>
>(initialAppsSearchState)
    .handleAction(
        ac.setAppsTableRequestParams,
        (state, { payload }): AppsSearchTableState => ({
            ...state,
            tableParams: {
                ...state.tableParams,
                ...payload,
            },
        }),
    )
    .handleAction(
        [ac.resetAppsTablePagination, updateIsNewOnlyAction, setLeadsFilterValue, appliedSignalsChangedAction],
        (state): AppsSearchTableState => ({
            ...state,
            tableParams: {
                ...state.tableParams,
                page: initialAppsSearchState.tableParams.page,
            },
        }),
    )
    .handleAction(
        ac.setAppsIsRowSelectionEnabled,
        (state, { payload }): AppsSearchTableState => ({
            ...state,
            isRowSelectionEnabled: payload,
        }),
    )
    .handleAction(
        ac.setAppsSelectedRows,
        (state, { payload }): AppsSearchTableState => ({
            ...state,
            selectedRows: payload,
        }),
    )
    .handleAction(
        ac.setAppsSearchText,
        (state, { payload }): AppsSearchTableState => ({
            ...state,
            searchText: payload,
            tableParams: {
                ...state.tableParams,
                page: initialAppsSearchState.tableParams.page,
            },
        }),
    )
    .handleAction(resetFilteringStateAction, (): AppsSearchTableState => initialAppsSearchState);

export default appsSearchReducer;
